import React, {Component} from 'react';
import {Card, CardBody, CardImage, CardText, CardTitle, Col, Fa, Mask, View} from "mdbreact";
import {Link} from "react-router-dom";
import {IMAGE_URL} from "../../config/Config";

export default class Merchant extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    render() {
        const { merchantObj } = this.props;
        return (
                <Col md="3" sm='6'>
                    <Card className="w-100 mb-5 rtl merchant-item" cascade>

                        <CardImage tag="div">
                            <View zoom>
                                <Link to={`/merchant/${merchantObj.id}`} className='mt-4'>
                                    <img src={IMAGE_URL + merchantObj.cover} className="w-100" style={{height:200}} alt={merchantObj.title} />
                                    <Mask className="flex-center" >
                                        {merchantObj.short_desc}
                                    </Mask>
                                </Link>
                            </View>
                        </CardImage>

                        <CardBody>

                            <div className="text-center">
                               <div className="mr-auto p-2">
                                   <CardTitle><Link to={`/merchant/${merchantObj.alias}`} >{merchantObj.title}</Link></CardTitle>
                                   <CardText style={{height:100}}>{merchantObj.short_desc}</CardText>
                               </div>
                                <div className="align-self-center" >
                                    <Link to={`/merchant/${merchantObj.id}`} className='btn btn-default btn-block'><Fa icon="search" className="text-white"/> مشاهده </Link>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
        );
    }
}





// WEBPACK FOOTER //
// ./src/components/merchants/Merchant.js